export default __webpack_public_path__ + "static/media/right.89817221.svg";